import { initialState } from '../state';
import { GuidedBoxesActions, GuidedBoxesActionTypes } from '../actions';
import { GuideBox } from 'diagram-js/lib/model';


export function guidedBoxes(state = initialState.guidedBoxes, action: GuidedBoxesActions): { [nodeId: string]: GuideBox} {
  switch (action.type) {
    case GuidedBoxesActionTypes.UPDATE_GUIDE_BOXES:
      return action.payload.guidedBoxNodeMap;
    default:
      return state;
  }
}
